<script lang="ts" setup>
import {ReccoRatingDTO} from '@/ts/types/dto/recco/rating.dto';
import FlatIconBtn from '@/vue/molecules/flat-icon-btn.vue';

defineProps<{
  loadingBookmarks: boolean;
  loadingLike: boolean;
  bookmarked: boolean;
  rating: ReccoRatingDTO;
}>();

const emit = defineEmits<{
  like: [];
  dislike: [];
  bookmark: [];
}>();
</script>
<template>
  <div class="buttons">
    <flat-icon-btn
      icon="bookmark.svg"
      :label="$t('btn-bookmark')"
      class="btn"
      :class="bookmarked ? 'btn--pressed' : ''"
      :loading="loadingBookmarks"
      :aria-pressed="bookmarked"
      @click="emit('bookmark')"
    />
    <div class="separator"/>
    <flat-icon-btn
      icon="thumbs-up.svg"
      :label="$t('btn-thumb-up')"
      class="btn"
      :class="rating === ReccoRatingDTO.LIKE ? 'btn--pressed' : ''"
      :loading="loadingLike"
      :aria-pressed="rating === ReccoRatingDTO.LIKE"
      @click="emit('like')"
    />
    <flat-icon-btn
      icon="thumbs-down.svg"
      :label="$t('btn-thumb-down')"
      class="btn"
      :class="rating === ReccoRatingDTO.DISLIKE ? 'btn--pressed' : ''"
      :loading="loadingLike"
      :aria-pressed="rating === ReccoRatingDTO.DISLIKE"
      @click="emit('dislike')"
    />
  </div>
</template>
<style lang="scss" scoped>
.buttons {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-spacing-2);
  background: var(--Neutral-UI-neutral-ui-20);
  border-radius: 30px;
  padding: var(--Spacing-spacing-1) var(--Spacing-spacing-4);
}

.separator {
  border-right: 2px solid var(--Neutral-UI-neutral-ui-40);
  height: 15px;
}

.btn {
  &--pressed {
    color: var(--Primary-primary-color-1);
  }
}

</style>
